import React, { useState } from 'react';
import { ProductDescriptionProps } from '../interfaces';
import { getDescriptionPreview } from './infoForProductById.utils';
import './ProductDescription.scss';



const ProductDescription: React.FC<ProductDescriptionProps> = ({ description }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const { isLongDescription, shortDescription } = getDescriptionPreview(description);

  return (
    <p className="product-description">
      {isExpanded ? description : shortDescription}
      {isLongDescription && (
        <button
          type="button"
          className="product-description__toggle"
          onClick={() => setIsExpanded((value) => !value)}
        >
          {isExpanded ? 'Hide' : 'More'}
        </button>
      )}
    </p>
  );
};

export default ProductDescription;
